/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-31 13:23:23
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:11:18
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SlugInput/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { QuestionCircleFilled } from '@ant-design/icons';
import React from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import Input from 'src/constrains/DebounceRequestInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { checkSlug } from 'src/request/common';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
const Slug = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    containerClassName,
    displayDangerousNotice,
    fixedParams,
    url,
    slugValid,
    customError,
    customHelper,
    required,
    disabled,
  } = props;
  //const [slugText, setSlugText] = React.useState(value || '');

  // React.useEffect(() => {
  //   sendReq(); //初始值娇艳
  // }, []);

  const checkFunc = (body) => {
    return checkSlug(url, body);
  };

  const filter = (str) => {
    if (str) {
      return str.replace(/[^0-9a-zA-Z_-]+/gi, '');
    } else {
      return str;
    }
  };

  const handleOnChange = (data) => {
    const { text, valid } = data;
    if (onChange) {
      onChange({
        slug: text,
        valid,
      });
    }
  };

  return (
    <ItemWrapper
      containerClassName={`${css.container} ${containerClassName || ''}`}
      rightPart={<CountWords count={(value || '').length} allCount={100} />}
      title={
        <div className={css.title}>
          {getI18n('general.uRLSlug')} {required && '*'}
          <Tip getI18n={getI18n} />
        </div>
      }>
      <Input
        value={value}
        onChange={handleOnChange}
        displayDangerousNotice={displayDangerousNotice}
        fixedParams={fixedParams}
        isValid={slugValid}
        customError={customError}
        customHelper={customHelper}
        filter={filter}
        maxLength={100}
        checkFunction={checkFunc}
        valueKey={'slug'}
        disabled={disabled}
      />
      <div className={css.urlContainer}>
        URL:/ <span className={css.urlInput}>{value}</span>
      </div>
    </ItemWrapper>
  );
};
export default Slug;
const Tip = (props) => {
  const { extra, title, getI18n } = props;
  return (
    <WhiteBackgroundTooltip
      title={
        <TooltipContainer>
          <TooltipTitle>
            {title || getI18n('general.uRLslugallowedcharacters')}
          </TooltipTitle>
          <TooltipContent>
            {getI18n('general.digits')} (0-9)
            <br /> {getI18n('general.letters')} (A-Z a-z)
            <br /> {getI18n('general.hyphen')} (-)
            <br /> {getI18n('general.underscore')} (_)
            {extra}
          </TooltipContent>
        </TooltipContainer>
      }
      placement='rightTop' //overlayClassName
    >
      <QuestionCircleFilled className={css.icon} />
    </WhiteBackgroundTooltip>
  );
};
export { Tip };
